// extracted by mini-css-extract-plugin
module.exports = {"ExtendButton":"NeutralFooter_ExtendButton__2aRuE","Hidden":"NeutralFooter_Hidden__2XLnM","Center":"NeutralFooter_Center__2-XXP"};